import { MAX_BEN_SENTRY_URL } from "@axtesys/kassen-app-ui"
import * as Sentry from "@sentry/browser"

import versionInfo from "~src/versionInfo.json"

export function setupWebPlatform() {
  setupSentry()
  injectGlobalStyles()
}

function setupSentry() {
  if (__DEV__) return
  Sentry.init({ dsn: MAX_BEN_SENTRY_URL })
  Sentry.setTag("version", versionInfo.version)
}

// Removes accessibility boxes around input components.
function injectGlobalStyles() {
  const style = document.createElement("style")
  style.textContent = `textarea, select, input, button { outline: none!important }`
  document.head.append(style)
}
